import Vue from 'vue';

Vue.filter('toPercent', (val, acc) => { // 小数转百分比 ，acc为保留小数位
  let num = parseFloat(val);
  // eslint-disable-next-line no-restricted-globals
  if (isNaN(num)) {
    num = 0;
  }
  // eslint-disable-next-line radix
  let accuracy = parseInt(acc);
  // eslint-disable-next-line no-restricted-globals
  if (isNaN(accuracy) || accuracy < 0 || accuracy > 10) {
    accuracy = 2;
  }
  return `${(num * 100).toFixed(accuracy)}%`;
});
Vue.filter('toFixed', (val, acc) => { // 小数转百分比 ，acc为保留小数位
  let num = parseFloat(val);
  // eslint-disable-next-line no-restricted-globals
  if (isNaN(num)) {
    num = 0;
  }
  // eslint-disable-next-line radix
  let accuracy = parseInt(acc);
  // eslint-disable-next-line no-restricted-globals
  if (isNaN(accuracy) || accuracy < 0 || accuracy > 10) {
    accuracy = 2;
  }
  return `${(num * 100).toFixed(accuracy)}%`;
});
